export const chainConfigs = {
  1: { PROXY_ADMIN: "0xDB392f4391462d60B8B4413ef72018Ab595Af9D0" },
  10: { PROXY_ADMIN: "0x4c7f7b6067fac9a737ecf2ca1a733fc85dd65a2b" },
  420: { PROXY_ADMIN: "0xbb45052B2260707655Dfd916a416264f5981192c" },
  8453: { PROXY_ADMIN: "0x004d6611884B4A661749B64b2ADc78505c3e1AB3" },
  42161: { PROXY_ADMIN: "0xF7DafC329C93D84267c0E7B146C0bD68807f6A03" },
  81457: { PROXY_ADMIN: "0x5b297B1b87f8De28C9fA7AFe183Db9F9e6295523" },
  84531: { PROXY_ADMIN: "0x02539E813cA450C2c7334e885423f4A899a063Fe" },
  84532: { PROXY_ADMIN: "0x5F14C23983c9e0840Dc60dA880349622f0785420" },
  421614: { PROXY_ADMIN: "0x256537b56007b32BabEB44E868EC8AA5cBF03D30" },
  7777777: { PROXY_ADMIN: "0xdEA20c96253dc2d64897D2b8d27A8d935dE74955" },
  11155111: { PROXY_ADMIN: "0xCE9F2e8EaFa11637F8A1CB60AE8AaC601Ae30f2D" },
  999999999: { PROXY_ADMIN: "0xdae22ce69Afcb7f4bc37D32E267645722949DE0E" },
};
export const addresses = {
  1: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x32C49770cC95F6A606Ae5a22A0a70e8F8ff64C75",
    MINTS_MANAGER_IMPL_VERSION: "0.1.3",
  },
  10: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  8453: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  42161: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  81457: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  84532: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  421614: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  7777777: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0xb0994EB9520C98C97e1F3953a5964535C2bd271A",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  11155111: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0x0000000000000000000000000000000000000000",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
  999999999: {
    MINTS_ETH_UNWRAPPER_AND_CALLER:
      "0xb0994EB9520C98C97e1F3953a5964535C2bd271A",
    MINTS_MANAGER_IMPL: "0x66a48d99A349e228618BB68f41496923958D5543",
    MINTS_MANAGER_IMPL_VERSION: "0.1.4",
  },
};
